module.exports = __webpack_public_path__ + "static/img/3s-platform-img4.e215e28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-platform-img4.png
// module id = D6xO
// module chunks = 0